import { AssetWithDimensions } from '../types';
import { generateRandomDimensions } from '../utils';
import { AssetType } from './asset-type';
import { MimeType } from './mime-type';

const thumbnailDimensions = generateRandomDimensions();

export const ASSET_GALLERY_GRID_SKELETON: AssetWithDimensions = {
    dateAdded: new Date().toISOString(),
    dimensions: thumbnailDimensions,
    fileSize: 1200000,
    id: '1',
    mimeType: MimeType.Unknown,
    name: 'Doc',
    permissions: [],
    tags: [],
    thumbnailDimensions: thumbnailDimensions,
    type: AssetType.Asset,
    url: '',
};
